"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDropdownMenu = require("@radix-ui/react-dropdown-menu");
var _HBMenuList = _interopRequireDefault(require("../HBMenu/HBMenuList"));
var _HBMenu = require("./HBMenu.styles");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _shared = require("../../utils/shared.utils");
var HBMenu = function HBMenu(_ref) {
  var testIdName = _ref.testIdName,
    testId = _ref.testId,
    target = _ref.target,
    menuItems = _ref.menuItems,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    subMenuSize = _ref.subMenuSize,
    hideArrowIconInSubmenu = _ref.hideArrowIconInSubmenu,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
    disabled = _ref.disabled,
    targetContainerStyle = _ref.targetContainerStyle,
    _ref$targetAsChild = _ref.targetAsChild,
    targetAsChild = _ref$targetAsChild === void 0 ? false : _ref$targetAsChild,
    offset = _ref.offset,
    alignOffset = _ref.alignOffset,
    _ref$withArrow = _ref.withArrow,
    withArrow = _ref$withArrow === void 0 ? true : _ref$withArrow,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    preventClickPropogation = _ref.preventClickPropogation,
    open = _ref.open,
    onOpenChange = _ref.onOpenChange,
    preventFocusOnClose = _ref.preventFocusOnClose,
    _ref$modal = _ref.modal,
    modal = _ref$modal === void 0 ? false : _ref$modal,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? '500px' : _ref$maxWidth,
    _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? '500px' : _ref$maxHeight,
    className = _ref.className;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'menu',
    componentName: 'HBMenu'
  });
  var jsx = /*#__PURE__*/_react["default"].createElement(_reactDropdownMenu.Root, {
    open: open,
    onOpenChange: onOpenChange,
    modal: modal
  }, /*#__PURE__*/_react["default"].createElement(_HBMenu.StyledTrigger, {
    disabled: disabled,
    style: targetContainerStyle,
    "data-testid": finalTestId ? "".concat(finalTestId, "-button") : undefined,
    asChild: targetAsChild,
    "data-prevent-focus-visible": !targetAsChild || null
  }, target), /*#__PURE__*/_react["default"].createElement(_reactDropdownMenu.Portal, null, /*#__PURE__*/_react["default"].createElement(_HBMenu.StyledContent, {
    align: align,
    side: placement,
    sideOffset: offset,
    alignOffset: alignOffset,
    className: className,
    "data-testid": finalTestId,
    $withArrow: withArrow,
    $maxWidth: maxWidth,
    $maxHeight: maxHeight,
    onCloseAutoFocus: preventFocusOnClose ? _shared.preventDefault : undefined
    // hideWhenDetached={true}
  }, /*#__PURE__*/_react["default"].createElement(_HBMenuList["default"], {
    menuItems: menuItems,
    size: size,
    subMenuSize: subMenuSize,
    hideArrowIconInSubmenu: hideArrowIconInSubmenu
  }), withArrow && /*#__PURE__*/_react["default"].createElement(_HBMenu.StyledArrow, null))));
  return preventClickPropogation ?
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
  _react["default"].createElement("div", {
    onClick: function onClick(ev) {
      return ev.stopPropagation();
    }
  }, jsx) : jsx;
};
var _default = exports["default"] = HBMenu;
//# sourceMappingURL=HBMenu.js.map